import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import apiInstance from "../../apiInstance";
import PopupModal from "../popups/PopupModal";

const PaymentMethods = () => {
    const user = useSelector((state) => state.currentUser);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [reload, setReload] = useState(0);
    const [error, setError] = useState("");
    const popupRef = useRef();

    const handleDeletion = async (id) => {
        try {
            const res = await apiInstance.delete(`/dashboard/payment-method/${id}`);
            setPaymentMethods(prev => prev.filter(item => item.id !== id));
            
        } catch (error) {
            console.error(`Error deleting payment method:`, error);
            setError(error.response?.data?.message || "Something went wrong");
        }
    }

    useEffect(() => {
        const fetchUserPaymentMethods = async () => {
            apiInstance
                .get(`/dashboard/payment-method`, {
                    params: {
                        userId: user.id
                    }
                })
                .then((response) => {
                    const fetchedPaymentMethods = response.data.paymentMethods || [];
                    setPaymentMethods(fetchedPaymentMethods);
                    
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load payment methods.");
                });
        }

        fetchUserPaymentMethods();

    }, [user.id, reload]);

    return (
        <div className="mjs-dash-section">
            <div className="mjs-dash-sec-header">
                <h4>Payment Methods</h4>
                <div className="mjs-flex-wrapper">
                    <i 
                        className="fa-solid fa-rotate-right mjs-cursor-pointer"
                        onClick={() => setReload((prev => prev + 1))}
                    ></i>
                    <button 
                        className="mjs-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            popupRef.current?.openPopup("addPaymentMethod");
                        }}
                    >Add New</button>
                </div>
            </div>
            <div className="mjs-dash-inner-container">
                {paymentMethods?.length > 0 ? paymentMethods.map((item) => (
                    <div className="mjs-dash-row">
                        <div className="mjs-dash-col">
                            <span className="mjs-strong">{item.paymentMethodType || '-'}</span>
                            <span>{item.card?.brand} ****{item.card?.last4}</span>
                            <span>{item.card?.country}</span>
                        </div>
                        <div className="mjs-dash-col">
                            <span>Expires: {item.card?.exp_month || '-'} / {item.card?.exp_year || '-'}</span>
                            <i
                                onClick={() => handleDeletion(item.id)}
                                title="Delete"
                                className="fa-solid fa-trash mjs-cursor-pointer"
                            ></i>
                        </div>
                    </div>
                )) : 'No records found'}
            </div>
            <div className="mjs-error">{error}</div>
            <PopupModal
                ref={popupRef}
            />
        </div>
    );
};

export default PaymentMethods;
